const localURL = "http://localhost:8000";
const remoteURL = "https://amergu.pythonanywhere.com";

const backendURL = remoteURL;

export {backendURL};